import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { NewsComponent } from './news.component';
import { NewsRoutingModule } from './news-routing.module';
import { NewsDetailComponent } from './news-detail/news-detail.component';
import { NewsFormComponent } from './news-form/news-form.component';

@NgModule({
  declarations: [NewsComponent, NewsFormComponent, NewsDetailComponent],
  imports: [
    SharedModule,
    NewsRoutingModule
  ]
})
export class NewsModule { }
